import { Component } from '@angular/core';

@Component({
  selector: 'app-reminder-en',
  imports: [],
  templateUrl: './reminder-en.html',
  styleUrl: './reminder-en.css',

})
export class EnglishReminder {}
